import { render, staticRenderFns } from "./PerformanceMarketingBanner.vue?vue&type=template&id=25482254"
import script from "./PerformanceMarketingBanner.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports